import { lockScroll, unlockScroll } from '../utils/util-functions';

export default (node) => {
  const modalCloseButton = node.querySelector('[data-modal-video-close]');
  const modalOverlay = document.querySelector('[data-modal-video-overlay]');
  const modalContainer = node.querySelector('[data-modal-video-container]');

  const openModal = (data) => {
    // get video content and send to modal-video liquid
    modalContainer.innerHTML = data.detail.innerHTML;
    const buttonPlay = modalContainer.querySelector(
      '[data-play-button-container]'
    );
    if (buttonPlay) {
      const vimeoButton = buttonPlay.getAttribute('data-play-button-container');
      if (vimeoButton === 'vimeo') {
        buttonPlay.classList.add('hidden');
      }
    }
    lockScroll();

    modalOverlay.classList.remove('hidden');
    node.classList.remove('hidden');
    node.classList.add('!translate-x-0');
    addEventListeners();
  };

  const closeModal = () => {
    unlockScroll();

    modalCloseButton.removeEventListener('click', closeModal);
    modalOverlay.removeEventListener('click', closeModal);
    const playButton = modalContainer.querySelector(
      '[data-play-button-container]'
    );
    if (playButton) {
      playButton.removeEventListener('click', () => {
        const video = modalContainer.querySelector('video');
        video.controls = true;
        video.play();
        video.muted = false;
        playButton.classList.add('hidden');
      });
    }

    node.classList.add('hidden');
    node.classList.remove('!translate-x-0');
    modalOverlay.classList.add('hidden');
    modalContainer.innerHTML = '';
  };

  const addEventListeners = () => {
    modalCloseButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);
    const playButton = modalContainer.querySelector(
      '[data-play-button-container]'
    );
    if (playButton) {
      playButton.addEventListener('click', () => {
        const video = modalContainer.querySelector('video');
        video.controls = true;
        video.play();
        video.muted = false;
        playButton.classList.add('hidden');
      });
    }
  };

  const init = () => {
    modalCloseButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);
    document.addEventListener('modal-video:open', openModal);
  };

  init();
};
